import { createSelector } from 'reselect';

const selectAccountingDomain = state => state.accounting;

const makeSelectAccountSystem = () =>
  createSelector(
    selectAccountingDomain,
    accountingState => 
      accountingState ? accountingState.get('accountSystem') : []
  );

const makeSelectAccountLoading = () =>
  createSelector(
    selectAccountingDomain,
    accountingState => 
      accountingState ? accountingState.get('isAccountLoading') : false
  );

const makeSelectAccountError = () =>
  createSelector(
    selectAccountingDomain,
    accountingState => 
      accountingState ? accountingState.get('accountError') : ''
  );
  
const makeSelectQuickBooksConnection = () =>
  createSelector(
    selectAccountingDomain,
    accountingState => 
      accountingState ? accountingState.get('quickBooksConnection') : ''
  );
  
const makeSelectAccountConnection = () =>
  createSelector(
    selectAccountingDomain,
    accountingState => 
      accountingState ? accountingState.get('accountConnection') : ''
  );
  
const makeSelectAccountConnectionUpdate = () =>
  createSelector(
    selectAccountingDomain,
    accountingState => 
      accountingState ? accountingState.get('accountConnectionUpdate') : false
  );

export {
  makeSelectAccountSystem,
  makeSelectAccountLoading,
  makeSelectAccountError,
  makeSelectQuickBooksConnection,
  makeSelectAccountConnection,
  makeSelectAccountConnectionUpdate
}
